module.exports = __webpack_public_path__ + "img/Bug.13d04569.svg";